export default __webpack_public_path__ + "static/media/2_0038.ea3e9cf5.webp";